module.exports = __webpack_public_path__ + "static/img/pc.9fc549b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/初中/pc.svg
// module id = 8v0C
// module chunks = 16